export function transformLevelContent(data) {
  return data.map(level => {
    if(level.subjects) return level

    const items = level.contentItems || ["General"];

    const subjects = items.map((title, idx) => ({
      title, 
      videos: Array.isArray(level.videos?.[idx]?.list)
        ? level.videos[idx].list
        : [],
      lectures: Array.isArray(level.lectures?.[idx]?.list)
        ? level.lectures[idx].list.map(k => ({ key: k, title: k }))
        : [],
      docs: Array.isArray(level.docs?.[idx]?.list)
        ? level.docs[idx].list
        : [],
      utils: []
    }));

    return {
      ...level,
      title: Array.isArray(level.title) 
      ? level.title[0] 
      : typeof level.title ==="string"
        ? level.title
        : "untitled",
      subjects,
      flatUtils: Array.isArray(level.utils) ? level.utils : []
      };
    });
}


